export default __webpack_public_path__ + "3b13c23802e8a967e9c072dda7a10385.svg";